import { type ReactNode } from 'react'
import classNames from 'classnames'
import { Icon } from 'shared/ui/Icon'
import { type ITypographyProps, Typography } from 'shared/ui/Typography'
import styles from './styles.module.scss'

export type IWarningProps = {
  text: ReactNode
  typographyProps?: Partial<ITypographyProps>
  size?: 'small' | 'medium'
  className?: string
}

export const Warning = ({ text, typographyProps, size = 'small', className }: IWarningProps) => {
  if (!text) return null

  return (
    <div className={classNames(styles.warning, className)}>
      <Icon icon={'infoCircle'} fontSize={16} />
      <Typography
        ariaLabel={'warning'}
        variant={size === 'small' ? 'text-input-helper' : 'body-sm-regular'}
        {...typographyProps}
        className={classNames(styles.text, typographyProps?.className)}
      >
        {text}
      </Typography>
    </div>
  )
}
